import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperGallery = () => {
  new Swiper('.swiper-gallery', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    direction: 'horizontal',
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });
};

export default swiperGallery;
